var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "add-prijem-btn"
  }, [_c('div', {
    staticClass: "text-small bl-color noselect pointer",
    on: {
      "click": _vm.openRestPopup
    }
  }, [_vm._v(" + pridať ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }